import api from "./api";

const licencaEmitidaService = {
  async criarLicencaEmitida(
    solicitacaoDeLicencaId,
    arquivo,
    certificadoPfxFile,
    certificadoSenha,
    extras = {}
  ) {
    try {
      const formData = new FormData();
      formData.append("SolicitacaoDeLicencaId", solicitacaoDeLicencaId);
      formData.append("Arquivo", arquivo);
      if (certificadoPfxFile) {
        formData.append("CertificadoPfx", certificadoPfxFile, certificadoPfxFile.name);
        formData.append("CertificadoSenha", certificadoSenha || "");
      }
      const {
        condicionantesGerais,
        condicionantesComPrazo,
        condicionantesEspecificas,
        observacoes,
        NumeroInformado,
        numeroInformado,
        NumeroDaLicenca,
        numeroDaLicenca,
      } = extras || {};
      if (condicionantesGerais != null)
        formData.append("CondicionantesGerais", condicionantesGerais);
      if (condicionantesComPrazo != null)
        formData.append("CondicionantesComPrazo", condicionantesComPrazo);
      if (condicionantesEspecificas != null)
        formData.append("CondicionantesEspecificas", condicionantesEspecificas);
      if (observacoes != null) formData.append("Observacoes", observacoes);
      const numeroInformadoValor = NumeroInformado ?? numeroInformado;
      if (numeroInformadoValor != null && String(numeroInformadoValor).trim() !== "") {
        formData.append("NumeroInformado", String(numeroInformadoValor).trim());
      }
      const numeroDaLicencaValor = NumeroDaLicenca ?? numeroDaLicenca;
      if (numeroDaLicencaValor != null && String(numeroDaLicencaValor).trim() !== "") {
        formData.append("NumeroDaLicenca", String(numeroDaLicencaValor).trim());
      }

      const response = await api.post("/LicencaEmitida", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erro ao criar licença emitida:", error);
      throw error;
    }
  },

  async obterPorSolicitacaoDeLicencaId(solicitacaoDeLicencaId) {
    try {
      const response = await api.get(
        `/LicencaEmitida/solicitacao/${solicitacaoDeLicencaId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao obter licença emitida:", error);
      throw error;
    }
  },

  async regenerarLicencaEmitida(solicitacaoDeLicencaId, arquivo, extras = {}) {
    try {
      const formData = new FormData();
      formData.append("SolicitacaoDeLicencaId", solicitacaoDeLicencaId);
      formData.append("Arquivo", arquivo);
      const {
        condicionantesGerais,
        condicionantesComPrazo,
        condicionantesEspecificas,
        observacoes,
        NumeroDaLicenca,
        numeroDaLicenca,
      } = extras || {};
      if (condicionantesGerais != null)
        formData.append("CondicionantesGerais", condicionantesGerais);
      if (condicionantesComPrazo != null)
        formData.append("CondicionantesComPrazo", condicionantesComPrazo);
      if (condicionantesEspecificas != null)
        formData.append("CondicionantesEspecificas", condicionantesEspecificas);
      if (observacoes != null) formData.append("Observacoes", observacoes);
      const numeroDaLicencaValor = NumeroDaLicenca ?? numeroDaLicenca;
      if (numeroDaLicencaValor != null && String(numeroDaLicencaValor).trim() !== "") {
        formData.append("NumeroDaLicenca", String(numeroDaLicencaValor).trim());
      }

      const response = await api.post("/LicencaEmitida/regenerar", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erro ao regenerar licença emitida:", error);
      throw error;
    }
  },

  async assinarLicenca(solicitacaoDeLicencaId, certificadoPfxFile, certificadoSenha) {
    try {
      const formData = new FormData();
      formData.append("certificadoPfx", certificadoPfxFile, certificadoPfxFile.name);
      formData.append("certificadoSenha", certificadoSenha);

      const response = await api.post(
        `/LicencaEmitida/assinar/${solicitacaoDeLicencaId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      return response.data;
    } catch (error) {
      console.error("Erro ao assinar licença:", error);
      throw error;
    }
  },
};

export default licencaEmitidaService;
